import { Component, OnInit, Input } from '@angular/core';
import { Users, Projects, Logs, Activities, Updates } from 'api/collections';
import { User, Project, Log, LogType, LogCategories, LogMessageType, Update, Activity } from 'api/models';
import { AlertController, ViewController, NavParams, ToastController, PopoverController, LoadingController, ActionSheetController} from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import * as permissions from '../../services/permissions';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { PictureService } from '../../services/picture';
import { AugmentedActivity } from '../../services/activityData';
import { LogMenuComponent } from '../../components/log-menu/log-menu';
import { LogView } from '../log-view/log-view';
import { ActivityDetailsPage } from '../activity-details/activity-details';
import { SUPPORT_ONE, SUPPORT_TWO } from "../../services/config";
import { App } from "ionic-angular";
import { APP_TITLE } from "../../services/config";

@Component({
  selector: 'help-modal',
  templateUrl: 'help-modal.html',
  styleUrls: ['/pages/help-modal/help-modal.scss']
})
export class HelpModalComponent implements OnInit {

  public disabled = false;
  // public helpImage = SUPPORT_ONE;
  title: string;
  helpImage: string;


  constructor(
    private _app: App,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private popoverCtrl: PopoverController,
    private pictureService: PictureService,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    public projectService: ProjectService
  ) {
    this.title = this.navParams.get('title');
    this.helpImage = this.navParams.get('helpImage');
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
    console.log("help page");
    this.title = this.navParams.get('title');
    this.helpImage = this.navParams.get('helpImage');

  }

  eventHandler(keyCode){
    if(keyCode==13){
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }

  exit() {
    this.viewCtrl.dismiss()
  }




}



// WEBPACK FOOTER //
// ./src/pages/help-modal/help-modal.ts